import { Stack, Typography } from "@mui/material";
import sgfin_logo from '../../assets/logos/NUS_SGFIN_logo.png';

export default function Footer1() {
    return (
        <Stack className="centered-container" direction={'row'} spacing={1} sx={{ mt: 4 }}>
            <Typography variant="caption">Powered by</Typography>
            <img src={sgfin_logo} alt='Sustainable and Green Finance Institute' style={{ maxWidth: 200 }}/>
        </Stack>
    )
}